const checker = {
	interacted: false,
};

window.addEventListener(
	'click',
	e => {
		checker.interacted = true;
	},
	{
		once: true,
	},
);

export default checker;
